<template>
  <Modal closable>
    <template v-slot:header>
      <h2>Del rute</h2>
    </template>

    <div>
      <div v-if="isPrivate">
        <p>Denne rute er privat. Kun <b>du</b> kan se ruten.</p>
      </div>
      <div v-else>
        <p>Del ruten "<b>{{ route.settings.name }}</b>" med dine venner/kollegaer via nedenstående link.</p>
        <div>
          <div class="flex flex-sb-c">
            <input class="fill-x" :value="getRouteLink(route.id)" v-focus style="margin: 1rem 0" spellcheck="false" readonly />
            <AppButton @click="copy()" icon="copy" color="primary" style="margin-left: .5rem" />
          </div>
          <div class="hint"><b>Alle</b> med linket kan <b>se</b> ruten.</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="flex flex-sb-c">
        <h4 style="margin:0">Privat rute<span class="plan-tag">PLUS</span></h4>
        <InputCheck v-model="isPrivate" isSwitch @update:modelValue="onSwitch()" />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import InputCheck from '@/components/inputs/InputCheck.vue'
import { store } from '@/store'
import { copyToClipboard } from '../../api/tools'
import { Route } from '@/api/tripply/models'
import { getRouteLink } from '@/api/tripply'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  components: { InputCheck },
  name: 'ShareRoute',
  setup(props) {

    const isPrivate = ref(props.route.settings.private)

    function onSwitch() {            
      store.route.updateSettings(props.route.id, {private: isPrivate.value}, true)
    }

    function copy() {
      copyToClipboard(getRouteLink(props.route.id))
    }
    
    return { getRouteLink, isPrivate, onSwitch, copy }
  }
})
</script>

<style>

</style>